module.exports = __webpack_public_path__ + "media/images/app/subscriptions/want-more-mobile-ab1e51692c4874166dc6d6de0bc2d9e7.webp";